// Auto-generated build information - do not edit manually
// Generated at: 2026-10-15T12:28:36.187Z

export const buildInfo = {
  "buildNumber": "220-dev1792067316187",
  "buildDate": "2026-10-15T12:28:36.187Z",
  "gitCommit": "8b95f92",
  "gitBranch": "dev",
  "gitTag": null,
  "environment": "dev"
} as const;

export type BuildInfo = typeof buildInfo;
